<template>
  <el-dialog
    title="合作咨询"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    @close="closeDialog"
  >
    <el-form
      ref="cooperateFormRef"
      :inline="true"
      :model="cooperateForm"
      :rules="cooperateFormRules"
      label-width="100px"
    >
      <el-form-item prop="enterpriseName" label="企业名称">
        <el-input v-model="cooperateForm.enterpriseName" placeholder="请填写企业名称"></el-input>
      </el-form-item>
      <div>
        <el-form-item prop="contacts" label="联系人">
          <el-input v-model="cooperateForm.contacts" placeholder="请填写联系人姓名"></el-input>
        </el-form-item>
        <el-form-item prop="mobile" label="联系电话">
          <el-input v-number:phone v-model="cooperateForm.mobile" placeholder="请填写联系电话"></el-input>
        </el-form-item>
      </div>
      <el-form-item prop="leaseNumber" label="计划租赁数量">
        <el-input v-model="cooperateForm.leaseNumber" placeholder="请填写计划租赁数量"></el-input>
      </el-form-item>
    </el-form>
    <p>为了保障您的合法权益，请您务必审慎阅读、充分知悉如下内容：</p>
    <p>1.鉴于您希望了解相关商品或服务的具体内容，商家需要获取相关个人和企业信息【以本页面采集为准】，用于跟您取得联系。</p>
    <p>2.就您提供的个人和企业信息，我们视为您已取得相应主体的授权。如未取得相应的授权导致第三人主张权益的，由您负责解决并承担全部责任。因此造成我们的直接损失和间接损失，我们皆有权向您索赔和追偿。</p>
    <p>3.本页面采集的个人和企业信息之获得授权，您一经填写/提交确认即生效且不可撤回。</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="submit" :loading="submitting">提交</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import { cooperate } from '@/api/carResource/index'

export default {
  name: 'cooperateDialog',
  props: {
    // 方案ID
    planId: {
      type: Number,
      default: null,
    },
    // 展示开关
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  data() {
    const validateAmount = (rule, value, callback) => {
      if (value === '' || value === null) callback()
      const num = Number(value)
      if (/\D/g.test(value) || num > 1000 || num < 1) {
        callback(new Error('请输入1~1000的整数'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: this.show,
      submitting: false,
      // 合作咨询表单
      cooperateForm: {
        leaseNumber: null,
        enterpriseName: null,
        contacts: null,
        mobile: null,
      },
      cooperateFormRules: {
        enterpriseName: [
          { required: true, message: '企业名称不能为空', trigger: 'blur' },
          { max: 20, message: '企业名称不能超过20位', trigger: 'blur' },
        ],
        contacts: [
          { required: true, message: '联系人不能为空', trigger: 'blur' },
          { max: 20, message: '联系人不能超过20位', trigger: 'blur' },
        ],
        mobile: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
        leaseNumber: [{ validator: validateAmount }],
      },
    }
  },
  watch: {
    show(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dialogVisible = newVal
      }
    },
  },
  methods: {
    // 提交咨询
    submit() {
      this.$refs.cooperateFormRef.validate((valid) => {
        if (valid) {
          this.submitting = true
          cooperate({
            ...this.cooperateForm,
            programmeId: this.planId,
          }).then((res) => {
            if (res.code === 1) {
              this.$message.success('提交成功')
              this.closeDialog()
            }
          }).finally(() => {
            this.submitting = false
          })
        }
      })
    },
    closeDialog() {
      this.init()
      this.$refs.cooperateFormRef.clearValidate()
      this.$emit('update:show', false)
    },
    init() {
      this.cooperateForm.enterpriseName = this.userInfo.tenantName
      this.cooperateForm.contacts = this.userInfo.userName
      this.cooperateForm.mobile = this.userInfo.userMobile
      this.cooperateForm.leaseNumber = null
    },
  },
  created() {
    this.init()
  },
}
</script>
